// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"0a52641b","453":"a313285d","745":"27dc0ab8"}[chunkId] + ".chunk.js";
};